import { View } from 'backbone.marionette';
import template from './index.jst';
import { Model } from "backbone";
import { getSponsorLogo } from '../../../../utils';
import { User } from '../../../../models';
import { PlayerPopup } from '../../../Fantasy';


export class MatchUpPlayersByMatching extends View {
	get template() {
		return template;
	}

	get className() {
		return 'hidden';
	}

	regions() {
		return {
			popup: '.js-player-popup'
		}
	}

	ui() {
		return {
			toggle: '.js-toggle-player-modal',
		}
	}

	initialize() {
		this.model = new Model({
			home_matching_players: [],
			away_matching_players: [],
			home_unique_players: [],
			away_unique_players: [],
			positions: {},
			selected_round_id: 0,
			no_player_message: 'Player will display when live'
		})

	}
	events() {
		return {
			'click @ui.toggle': 'onPlayerShowPopup',
		}
	}

	
	onPlayerShowPopup(event) {
		const { playerId } = event.currentTarget.dataset;
		const
			player = this.options.players.get(parseInt(playerId, 10)).toJSON();

		if (!player) {
			return this;
		}

		const sponsor_logo = getSponsorLogo();

		const actual_round_id = Number(this.options.round_id);
		const last_round_id = actual_round_id - 1;
		const next_round_id = actual_round_id + 1;

		this.showChildView('popup', this.getPlayerPopupView({
			...player,
			actual_round_id,
			last_round_id,
			next_round_id,
			has_assistant_coach: User.has_assistant_coach,
			sponsor_logo,
			rounds: this.options.rounds,
			is_from_field: false,
			bench_rank: undefined,
			is_unlimited_trades: undefined,
			is_from_bench: undefined,
			field_position: undefined,
			field_position_key: undefined,
			is_in_salary: undefined,
			is_locked: undefined,
			is_favourite: false
		}));
	}

	getPlayerPopupView(args) {
		return new PlayerPopup({
			model: new Model(args)
		})
	}


	init({ positions, matchup_fixture, selected_round,
		home_matching_players, away_matching_players, home_unique_players, away_unique_players
	}) {

		this.model.set({
			selected_round_id: selected_round.id,
			positions,
			...matchup_fixture,
			home_matching_players,
			away_matching_players,
			home_unique_players,
			away_unique_players
		});

		this.render();
	}
}

export default MatchUpPlayersByMatching;